// Application-wide constants

export const APP_NAME = 'fyle';
export const APP_DESCRIPTION = 'Producer Cloud - SaaS for producers';
export const APP_VERSION = '1.0.0';

export const API_BASE_URL =
  import.meta.env.VITE_API_STRIPE ||
  import.meta.env.VITE_API_BASE_URL ||
  'http://localhost:4000/api';
// YouTube API Base URL - normalize to remove trailing slashes and ensure proper format
const rawYouTubeApiUrl = import.meta.env.VITE_YOUTUBE_API_URL || 'http://localhost:4001';
export const YOUTUBE_API_BASE_URL = rawYouTubeApiUrl.replace(/\/+$/, ''); // Remove trailing slashes

// Meta API Base URL (BPM/Key Detection)
export const META_API_BASE_URL = 
  import.meta.env.VITE_META_API_URL || 
  'http://localhost:3002';

// Debug logging in development
if (import.meta.env.DEV) {
  console.log('🔍 YouTube API Base URL:', YOUTUBE_API_BASE_URL);
  console.log('🔍 Raw env value:', import.meta.env.VITE_YOUTUBE_API_URL);
  console.log('🔍 Meta API Base URL:', META_API_BASE_URL);
}
export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL || '';

// Storage limits (in bytes)
export const STORAGE_LIMITS = {
  FREE: 2 * 1024 * 1024 * 1024, // 2GB
  PRO: 50 * 1024 * 1024 * 1024, // 50GB
  PREMIUM: 500 * 1024 * 1024 * 1024, // 500GB
};

// File upload limits
export const MAX_FILE_SIZE = 500 * 1024 * 1024; // 500MB
export const ALLOWED_AUDIO_FORMATS = [
  'audio/mpeg',
  'audio/wav',
  'audio/flac',
  'audio/aiff',
  'audio/x-aiff',
  'audio/ogg',
];

// Audio processing
export const PREVIEW_DURATION = 30; // seconds
export const WAVEFORM_SAMPLES = 1000;

// UI Constants
export const SIDEBAR_WIDTH = 294;
export const HEADER_HEIGHT = 100;

// Color coding for file types
export const FILE_TYPE_COLORS = {
  beat: '#4A90E2',
  sample: '#30d870',
  loop: '#FF9500',
  oneshot: '#9B59B6',
  pack: '#E74C3C',
};

// Tag colors
export const TAG_COLORS = {
  category: '#30d85c73',
  genre: '#30d870cc',
  bpm: '#30d870cc',
  key: '#30d870cc',
  mood: '#FFB347',
  instrument: '#6BA5E7',
  custom: '#30d870cc',
};

// Routes
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  CLOUD_EXPLORER: '/cloud-explorer',
  SHARING: '/sharing',
  VERSION: '/version',
  TAG_EDITOR: '/tag-editor',
  NAME_PRESETS: '/name-presets',
  TEAM: '/team',
  BILLING: '/billing',
  SUPPORT: '/support',
  YOUTUBE: '/youtube',
  SETTINGS: '/settings',
  LOGIN: '/login',
  SIGNUP: '/signup',
  UPLOAD: '/upload',
  RESET_PASSWORD_REQUEST: '/reset-password-request',
  RESET_PASSWORD: '/reset-password',
  SET_PASSWORD: '/set-password',
  EMAIL_VERIFICATION: '/verify-email',
  EMAIL_CHANGE_CONFIRM: '/email-change-confirm',
  ERROR_DENIED: '/error-denied',
  BILLING_SUCCESS: '/billing/success',
  BILLING_CANCEL: '/billing/cancel',
  /** Dedizierte Dropbox-OAuth-Callback-URL – in Dropbox App Console eintragen */
  DROPBOX_CALLBACK: '/auth/dropbox/callback',
} as const;


